import axios from "axios";
import { deviceType, getUA, osName } from "react-device-detect";
import appStore from "../store";

function fsEvent(data, error_location) {
  
  const { member } = appStore;
  const body = {
    error_title: "Event Tracking",
    error_message: "User selected location",
    error_location: error_location,
    platform: "udrive",
    type: "udrive_web_event_tracking",
    additional_info: {
      report_user_info: {
        user_id: member?.id || 'visitor',
        user_name: member?.fullname || null,
        user_phone: member?.phone || null,
        user_payment_method: member?.payment_method || null,
        device_info: {
          user_agent: getUA,
          device_type: deviceType,
          os_name: osName,
        },
        event_info: data,
      },
    },
  };
  axios.post("https://xchat.udrive.city/api/reportBug", body);
}

export default fsEvent;
